import React, { useEffect, useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import '../../styles/payments.css'
import LayoutWithAccountCard from '../../layout/Layout/layout-account-card'
import { MENU_OPTIONS } from '../../layout/Layout/menu-options'
import { Col, Row } from 'react-bootstrap'
import { accountsSelector, getMenuListSelector } from '../../selectors'
import { useSelector } from 'react-redux'
import MenuCard from '../../layout/Navigation/menu-card'
const menuDetails = MENU_OPTIONS.filter((ele) => ele.key === 'PAYMENTS')[0]?.children


export default function Payments() {
  const history = useHistory()
  const accounts = useSelector(accountsSelector) || []
  const menuConfig = useSelector(getMenuListSelector)['PAYMENTS'] || {}

  return (
    <LayoutWithAccountCard breadCumKey='PAYMENTS'>
      <Row>
        {Object.keys(menuConfig).length > 0 &&
          menuDetails.map((option, index) => (
            <>
              {menuConfig[option.key] && (
                <MenuCard
                  handleMenuCallback={() => (accounts.length > 0 ? history.push(option?.link) : '')}
                  icon={option.icon}
                  name={option.title}
                  description={option.desc}
                  key={index}
                />
              )}
            </>
          ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
